export interface SelectOptionType {
    value: string;
    label: string;
}

export interface FilterConfig {
    key: string;
    label: string;
    defaultValue: string;
    options: SelectOptionType[];
}

export interface FilterValues {
    distance: string;
    size: string;
    age: string;
    assessment: string;
    orderBy: string;
}

export const FILTER_CONFIGS: FilterConfig[] = [
    {
        key: "distance",
        label: "Distance",
        defaultValue: "All",
        options: [
            { value: "All", label: "All" },
            { value: "Less than 5 miles", label: "Less than 5 miles" },
            { value: "Less than 10 miles", label: "Less than 10 miles" },
            { value: "Less than 15 miles", label: "Less than 15 miles" },
        ],
    },
    {
        key: "size",
        label: "Size",
        defaultValue: "All",
        options: [
            { value: "All", label: "All" },
            { value: "±10% of subject", label: "±10% of subject" },
            { value: "±20% of subject", label: "±20% of subject" },
            { value: "±30% of subject", label: "±30% of subject" },
            { value: "±50% of subject", label: "±50% of subject" },
        ],
    },
    {
        key: "age",
        label: "Age",
        defaultValue: "All",
        options: [
            { value: "All", label: "All" },
            { value: "±5 years of subject", label: "±5 years of subject" },
            { value: "±10 years of subject", label: "±10 years of subject" },
            { value: "±15 years of subject", label: "±15 years of subject" },
        ],
    },
    {
        key: "assessment",
        label: "Assessment",
        defaultValue: "All",
        options: [
            { value: "All", label: "All" },
            { value: "Within 2 years", label: "Within 2 years" },
            { value: "Within 3 years", label: "Within 3 years" },
            { value: "Within 5 years", label: "Within 5 years" },
        ],
    },
    {
        key: "orderBy",
        label: "Order by",
        defaultValue: "Recommendations",
        options: [
            { value: "Recommendations", label: "Recommendations" },
            { value: "Distance", label: "Distance" },
            { value: "Size difference", label: "Size difference" },
            { value: "Age difference", label: "Age difference" },
        ],
    },
];
